import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { asDict, bool } from '@/lib/api/parse';

export function useDiscoveryEnabled(): boolean {
  const status = useQuery({
    queryKey: ['event-discovery', 'enabled'],
    queryFn: async ({ signal }) =>
      bool(
        asDict(await api.get<unknown>('ingestion', '/api/v1/event-discovery/status', { signal })),
        'enabled',
      ),
    staleTime: 5 * 60_000,
  });
  return status.data === true;
}
